import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../services/api";

const DriverManagement = () => {
  const navigate = useNavigate();
  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [selectedDriver, setSelectedDriver] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [detailLoading, setDetailLoading] = useState(false);
  const [actionLoading, setActionLoading] = useState(false);

  const [vehicleForm, setVehicleForm] = useState({ model: "", number: "", type: "" });
  const [vehicleLoading, setVehicleLoading] = useState(false);
   const [blockLoading, setBlockLoading] = useState(false);

  const [approvalFilter, setApprovalFilter] = useState("");
  const [availabilityFilter, setAvailabilityFilter] = useState("");

    const [searchTerm, setSearchTerm] = useState("");
    const [vehicleTypeFilter, setVehicleTypeFilter] = useState("");
    const [addressForm, setAddressForm] = useState({ street: "", city: "", state: "", zipCode: "" });
const [addressLoading, setAddressLoading] = useState(false);
const [onlineFilter, setOnlineFilter] = useState("");

  // =========================
  // FETCH ALL DRIVERS
  // =========================
  const fetchDrivers = async () => {
    try {
      setLoading(true);

      const params = new URLSearchParams();

      if (approvalFilter) {
        params.append("approvalStatus", approvalFilter);
      }

      if (availabilityFilter) {
        params.append("status", availabilityFilter);
      }

      const res = await API.get(`/all-drivers?${params.toString()}`);

      if (res.data.success) {
        setDrivers(res.data.drivers);
      }

    } catch (err) {
      setError(err.response?.data?.message || "Failed to load drivers");
    } finally {
      setLoading(false);
    }
  };

  // =========================
  // VIEW DRIVER PROFILE
  // =========================
  const handleViewProfile = async (driverId) => {
    try {

      setDetailLoading(true);

      const res = await API.get(`/driver/${driverId}`);

      /*if (res.data.success) {
        setSelectedDriver(res.data.driver);
        setIsModalOpen(true);
      }*/

      if (res.data.success) {
        setSelectedDriver(res.data.driver);
        setVehicleForm({
          model: res.data.driver.vehicleDetails?.model || "",
          number: res.data.driver.vehicleDetails?.number || "",
          type: res.data.driver.vehicleDetails?.type || "",
        });



        setAddressForm({
  street: res.data.driver.address?.street || "",
  city: res.data.driver.address?.city || "",
  state: res.data.driver.address?.state || "",
  zipCode: res.data.driver.address?.zipCode || "",
});



        setIsModalOpen(true);
      }

    } catch (err) {

      alert("Error fetching driver profile details");

    } finally {

      setDetailLoading(false);

    }
  };

  // =========================
  // UPDATE DOCUMENT STATUS
  // =========================
  const handleUpdateDocStatus = async (docType, newStatus) => {

    let rejectionReason = "";

    if (newStatus === "rejected") {

      rejectionReason = prompt("Please enter rejection reason:");

      if (!rejectionReason) return;

    }

    try {

      setActionLoading(true);

      const res = await API.put(
        `/driver/document-status/${selectedDriver._id}`,
        {
          documentType: docType,
          status: newStatus,
          rejectionReason,
          remarks: `Updated by Admin on ${new Date().toLocaleDateString()}`
        }
      );

      if (res.data.success) {

        setSelectedDriver((prev) => ({
          ...prev,
          documents: res.data.documents,
          overallApprovalStatus: res.data.overallApprovalStatus,
          isActive: res.data.isActive,
        }));

        fetchDrivers();

        alert(`Document ${newStatus} successfully`);

      }

    } catch (err) {

      alert(err.response?.data?.message || "Failed to update document");

    /*}finally {

      setActionLoading(false);

    }
  };

  useEffect(() => {*/



      } finally {

      setActionLoading(false);

    }
  };




    const handleToggleBlock = async (isBlocked, blockReason = "") => {
    try {
      setBlockLoading(true);

      const res = await API.put(`/driver/${selectedDriver._id}/block`, {
        isBlocked,
        blockReason,
      });

      if (res.data.success) {
        setSelectedDriver((prev) => ({
          ...prev,
          isBlocked: res.data.driver.isBlocked,
          blockReason: res.data.driver.blockReason,
        }));

        fetchDrivers();
        alert(isBlocked ? "Driver blocked successfully." : "Driver unblocked successfully.");
      }
    } catch (err) {
      alert(err.response?.data?.message || "Failed to update block status");
    } finally {
      setBlockLoading(false);
    }
  };


  // =========================
  // UPDATE VEHICLE DETAILS
  // =========================
  const handleUpdateVehicle = async () => {
    try {
      setVehicleLoading(true);

      const res = await API.put(
        `/driver/${selectedDriver._id}/vehicle-type`,
        {
          model: vehicleForm.model,
          number: vehicleForm.number,
          vehicleType: vehicleForm.type,
        }
      );

      if (res.data.success) {
        setSelectedDriver((prev) => ({
          ...prev,
          vehicleDetails: res.data.driver.vehicleDetails,
        }));

        fetchDrivers();

        alert("Vehicle details updated successfully");
      }

    } catch (err) {

      alert(err.response?.data?.message || "Failed to update vehicle details");

    } finally {

      setVehicleLoading(false);

    }
  };


  const handleUpdateAddress = async () => {
  try {
    setAddressLoading(true);

    const res = await API.put(`/driver/${selectedDriver._id}/address`, {
      street: addressForm.street,
      city: addressForm.city,
      state: addressForm.state,
      zipCode: addressForm.zipCode,
    });

    if (res.data.success) {
      setSelectedDriver((prev) => ({
        ...prev,
        address: res.data.driver.address,
      }));

      fetchDrivers();
      alert("Address updated successfully");
    }
  } catch (err) {
    alert(err.response?.data?.message || "Failed to update address");
  } finally {
    setAddressLoading(false);
  }
};

const handleToggleOnlineStatus = async (driverId, currentIsOnline) => {
  try {
    const res = await API.put(`/driver/${driverId}/online-status`, {
      isOnline: !currentIsOnline,
    });

    if (res.data.success) {
      setDrivers((prev) =>
        prev.map((d) =>
          d._id === driverId ? { ...d, isOnline: res.data.isOnline } : d
        )
      );

      if (selectedDriver && selectedDriver._id === driverId) {
        setSelectedDriver((prev) => ({ ...prev, isOnline: res.data.isOnline }));
      }
    }
  } catch (err) {
    alert(err.response?.data?.message || "Failed to toggle online status");
  }
};


  useEffect(() => {





    fetchDrivers();
  }, [approvalFilter, availabilityFilter]);


   /*    const filteredDrivers = drivers.filter((d) => {
    const matchesName = d.name?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesVehicle = vehicleTypeFilter
      ? d.vehicleDetails?.type === vehicleTypeFilter
      : true;
    return matchesName && matchesVehicle;
  });*/




  const filteredDrivers = drivers.filter((d) => {
  const matchesName = d.name?.toLowerCase().includes(searchTerm.toLowerCase());
  const matchesVehicle = vehicleTypeFilter
    ? d.vehicleDetails?.type === vehicleTypeFilter
    : true;
  const matchesOnline = onlineFilter === "" 
    ? true 
    : String(d.isOnline) === onlineFilter;

  return matchesName && matchesVehicle && matchesOnline;
});



  if (loading && drivers.length === 0) {
    return <div style={styles.loading}>Loading Fleet Data...</div>;
  }

  return (
    <div style={styles.page}>

      {/* HEADER */}
      <div style={styles.header}>

        <div>
          <h2 style={styles.title}>Driver Fleet</h2>
          <p style={styles.subtitle}>
            Verify documents and monitor availability
          </p>
        </div>

        <div style={styles.filterGroup}>

          <select
            style={styles.select}
            value={approvalFilter}
            onChange={(e) => setApprovalFilter(e.target.value)}
          >
            <option value="">All Approvals</option>
            <option value="pending">Pending</option>
            <option value="approved">Approved</option>
            <option value="rejected">Rejected</option>
          </select>

          <select
            style={styles.select}
            value={availabilityFilter}
            onChange={(e) => setAvailabilityFilter(e.target.value)}
          >
            <option value="">All Status</option>
            <option value="FREE">Available</option>
            <option value="BUSY">Busy</option>
          </select>

          {/*<div style={styles.badgeCount}>
            {drivers.length} Drivers
          </div>

        </div>

      </div>*/}

          <input
            type="text"
            placeholder="Search by name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            style={styles.select}
          />

          <select
            style={styles.select}
            value={vehicleTypeFilter}
            onChange={(e) => setVehicleTypeFilter(e.target.value)}
          >
            <option value="">All Vehicle Types</option>
            <option value="bike">Bike</option>
            <option value="ape">3 Wheeler (Ape)</option>
            <option value="pickup">Pickup / Mini Truck</option>
            <option value="truck">Truck</option>
          </select>



<select
  style={styles.select}
  value={onlineFilter}
  onChange={(e) => setOnlineFilter(e.target.value)}
>
  <option value="">All Online States</option>
  <option value="true">Online</option>
  <option value="false">Offline</option>
</select>



          <div style={styles.badgeCount}>
            {filteredDrivers.length} Drivers
          </div>

        </div>

      </div>

      {error && <div style={styles.error}>{error}</div>}

      {/* DRIVER GRID */}
       <div style={styles.grid}>

        {filteredDrivers.map((d) => (

          <div key={d._id} style={styles.card}>

            <div style={styles.cardTop}>

              <span
                style={{
                  ...styles.statusBadge,
                  backgroundColor:
                    d.status === "FREE" ? "#dcfce7" : "#fee2e2",
                  color:
                    d.status === "FREE" ? "#166534" : "#991b1b",
                }}
              >
                {d.status}
              </span>

              <span
                style={{
                  ...styles.approvalBadge,
                  backgroundColor:
                    getApprovalColor(d.overallApprovalStatus).bg,
                  color:
                    getApprovalColor(d.overallApprovalStatus).text,
                }}
              >
                {d.overallApprovalStatus}
              </span>



<button
  style={{
    padding: "4px 10px",
    borderRadius: "6px",
    border: "none",
    fontWeight: "700",
    fontSize: "11px",
    cursor: "pointer",
    backgroundColor: d.isOnline ? "#dcfce7" : "#f1f5f9",
    color: d.isOnline ? "#166534" : "#64748b",
  }}
  onClick={() => handleToggleOnlineStatus(d._id, d.isOnline)}
>
  {d.isOnline ? "● Online" : "○ Offline"}
</button>





            </div>

            <h3 style={styles.driverName}>{d.name}</h3>

            <p style={styles.contactInfo}>{d.phone}</p>

            <div style={styles.vehicleBox}>

              <div style={styles.label}>Vehicle Details</div>

              <div style={styles.vehicleText}>
                <strong>{d.vehicleDetails?.model}</strong>
                {" "}
                ({d.vehicleDetails?.type})
              </div>

              <div style={styles.plateNumber}>
                {d.vehicleDetails?.number}
              </div>

            </div>

            <div style={styles.statsRow}>

              <div style={styles.statItem}>
                <span style={styles.statLabel}>Wallet</span>
                <span style={styles.statValue}>
                  ₹{d.walletBalance || 0}
                </span>
              </div>

              <div style={styles.statItem}>
                <span style={styles.statLabel}>Earnings</span>
                <span style={styles.statValue}>
                  ₹{d.totalEarnings || 0}
                </span>
              </div>

            </div>


            <div style={{ display: "flex", gap: "8px" }}>

            <button
              style={styles.viewBtn}
              onClick={() => handleViewProfile(d._id)}
            >
              {detailLoading && selectedDriver?._id === d._id
                ? "Processing..."
                : "Verify Documents"}
            </button>

            <button
                style={{ ...styles.viewBtn, flex: 1, background: "#eef2ff", color: "#4338ca", borderColor: "#c7d2fe" }}
                onClick={() => navigate(`/dashboard/wallet/${d._id}`)}
              >
                View Wallet
              </button>
              </div>

          </div>

        ))}

      </div>

      {/* MODAL */}
      {isModalOpen && selectedDriver && (

        <div
          style={styles.overlay}
          onClick={() => setIsModalOpen(false)}
        >

          <div
            style={styles.modal}
            onClick={(e) => e.stopPropagation()}
          >

            <div style={styles.modalHeader}>

              <div>

                <h3 style={styles.modalTitle}>
                  {selectedDriver.name}
                </h3>

                <div style={{
                  display: "flex",
                  gap: "10px",
                  marginTop: "5px"
                }}>

                  <span style={styles.modalSubtitle}>
                    ID: {selectedDriver._id.slice(-6)}
                  </span>

                  <span
                    style={{
                      ...styles.approvalBadge,
                      fontSize: "10px",
                      backgroundColor:
                        getApprovalColor(selectedDriver.overallApprovalStatus).bg,
                      color:
                        getApprovalColor(selectedDriver.overallApprovalStatus).text,
                    }}
                  >
                    {selectedDriver.overallApprovalStatus}
                  </span>

                </div>

              </div>

              <button
                style={styles.closeBtn}
                onClick={() => setIsModalOpen(false)}
              >
                ×
              </button>

            </div>

            <div style={styles.modalBody}>

              <h4 style={styles.sectionTitle}>
                Document Verification
              </h4>

              <div style={styles.docGrid}>

                {["license", "rc", "addharcard"].map((docKey) => {

                  const doc = selectedDriver.documents?.[docKey];

                  return (

                    <div key={docKey} style={styles.docCard}>

                      <div style={{
                        display: "flex",
                        justifyContent: "space-between"
                      }}>

                        <p style={styles.docLabel}>
                          {docKey.toUpperCase()}
                        </p>

                        <span style={{
                          fontSize: "10px",
                          fontWeight: "700",
                          color:
                            doc?.status === "approved"
                              ? "#166534"
                              : "#92400e"
                        }}>
                          {doc?.status || "Missing"}
                        </span>

                      </div>

                      {doc?.url ? (

                        <>

                          <a
                            href={doc.url}
                            target="_blank"
                            rel="noreferrer"
                            style={styles.docLink}
                          >
                            View Document
                          </a>

                          <div style={styles.previewContainer}>

                            <img
                              src={doc.url}
                              alt={docKey}
                              style={styles.previewImage}
                              onError={(e) => {
                                e.target.style.display = "none";
                              }}
                            />

                          </div>

                          <div style={styles.actionRow}>

                            <button
                              disabled={
                                actionLoading ||
                                doc.status === "approved"
                              }
                              onClick={() =>
                                handleUpdateDocStatus(docKey, "approved")
                              }
                              style={{
                                ...styles.actionBtn,
                                backgroundColor: "#dcfce7",
                                color: "#166534"
                              }}
                            >
                              Approve
                            </button>

                            <button
                              disabled={
                                actionLoading ||
                                doc.status === "rejected"
                              }
                              onClick={() =>
                                handleUpdateDocStatus(docKey, "rejected")
                              }
                              style={{
                                ...styles.actionBtn,
                                backgroundColor: "#fee2e2",
                                color: "#991b1b"
                              }}
                            >
                              Reject
                            </button>

                          </div>

                        </>

                      ) : (

                        <p style={{
                          fontSize: "11px",
                          color: "#94a3b8"
                        }}>
                          No file uploaded
                        </p>

                      )}

                      {doc?.rejectionReason && (
                        <p style={styles.rejectionText}>
                          Reason: {doc.rejectionReason}
                        </p>
                      )}

                    </div>

                  );
                })}

              </div>



{/* VEHICLE DETAILS */}
              <div style={styles.bankSection}>

                <h4 style={styles.sectionTitle}>
                  Vehicle Details
                </h4>

                <div style={styles.bankGrid}>

                  <div>
                    <p style={styles.docLabel}>Model</p>
                    <input
                      style={{ ...styles.select, width: "100%" }}
                      value={vehicleForm.model}
                      onChange={(e) =>
                        setVehicleForm((prev) => ({ ...prev, model: e.target.value }))
                      }
                    />
                  </div>

                  <div>
                    <p style={styles.docLabel}>Number</p>
                    <input
                      style={{ ...styles.select, width: "100%" }}
                      value={vehicleForm.number}
                      onChange={(e) =>
                        setVehicleForm((prev) => ({ ...prev, number: e.target.value }))
                      }
                    />
                  </div>

                  <div>
                    <p style={styles.docLabel}>Type</p>
                    <select
                      style={{ ...styles.select, width: "100%" }}
                      value={vehicleForm.type}
                      onChange={(e) =>
                        setVehicleForm((prev) => ({ ...prev, type: e.target.value }))
                      }
                    >
                      <option value="bike">Bike</option>
                      <option value="ape">3 Wheeler (Ape)</option>
                      <option value="pickup">Pickup / Mini Truck</option>
                      <option value="truck">Truck</option>
                    </select>
                  </div>

                </div>

                <button
                  style={{ ...styles.viewBtn, marginTop: "15px", background: "#1e293b", color: "#fff", borderColor: "#1e293b" }}
                  disabled={vehicleLoading}
                  onClick={handleUpdateVehicle}
                >
                  {vehicleLoading ? "Updating..." : "Update Vehicle Details"}
                </button>

              </div>



               {/* BLOCK / UNBLOCK */}
              <div style={styles.bankSection}>
                <h4 style={styles.sectionTitle}>Account Status</h4>
                {selectedDriver.isBlocked ? (
                  <>
                    <p style={{ fontSize: "13px", color: "#991b1b", marginBottom: "10px" }}>
                      🚫 Blocked — Reason: {selectedDriver.blockReason || "No reason provided"}
                    </p>
                    <button
                      style={{ ...styles.viewBtn, background: "#dcfce7", color: "#166534", borderColor: "#bbf7d0" }}
                      disabled={blockLoading}
                      onClick={() => handleToggleBlock(false)}
                    >
                      {blockLoading ? "Updating..." : "Unblock Driver"}
                    </button>
                  </>
                ) : (
                  <button
                    style={{ ...styles.viewBtn, background: "#fee2e2", color: "#991b1b", borderColor: "#fecaca" }}
                    disabled={blockLoading}
                    onClick={() => {
                      const reason = prompt("Enter reason for blocking this driver:");
                      if (reason === null) return; // cancelled
                      handleToggleBlock(true, reason);
                    }}
                  >
                    {blockLoading ? "Updating..." : "Block Driver"}
                  </button>
                )}
              </div>



{/* ADDRESS DETAILS EDIT FORM */}
<div style={{ ...styles.bankSection, marginTop: "20px" }}>
  <h4 style={styles.sectionTitle}>Address Details</h4>
  <div style={styles.bankGrid}>
    <div>
      <p style={styles.docLabel}>Street Address</p>
      <input
        style={{ ...styles.select, width: "100%" }}
        value={addressForm.street}
        onChange={(e) =>
          setAddressForm((prev) => ({ ...prev, street: e.target.value }))
        }
      />
    </div>

    <div>
      <p style={styles.docLabel}>City</p>
      <input
        style={{ ...styles.select, width: "100%" }}
        value={addressForm.city}
        onChange={(e) =>
          setAddressForm((prev) => ({ ...prev, city: e.target.value }))
        }
      />
    </div>

    <div>
      <p style={styles.docLabel}>State</p>
      <input
        style={{ ...styles.select, width: "100%" }}
        value={addressForm.state}
        onChange={(e) =>
          setAddressForm((prev) => ({ ...prev, state: e.target.value }))
        }
      />
    </div>

    <div>
      <p style={styles.docLabel}>Zip Code</p>
      <input
        style={{ ...styles.select, width: "100%" }}
        value={addressForm.zipCode}
        onChange={(e) =>
          setAddressForm((prev) => ({ ...prev, zipCode: e.target.value }))
        }
      />
    </div>
  </div>

  <button
    style={{
      ...styles.viewBtn,
      marginTop: "15px",
      background: "#1e293b",
      color: "#fff",
      borderColor: "#1e293b",
    }}
    disabled={addressLoading}
    onClick={handleUpdateAddress}
  >
    {addressLoading ? "Updating..." : "Update Address"}
  </button>
</div>


              {/* BANK DETAILS */}
              <div style={styles.bankSection}>

                <h4 style={styles.sectionTitle}>
                  Banking Details
                </h4>

                <div style={styles.bankGrid}>

                  <div>
                    <p style={styles.docLabel}>UPI ID</p>
                    <p style={styles.bankValue}>
                      {selectedDriver.upiId || "N/A"}
                    </p>
                  </div>

                  <div>
                    <p style={styles.docLabel}>Account Number</p>
                    <p style={styles.bankValue}>
                      {selectedDriver.bankaccountnumber || "N/A"}
                    </p>
                  </div>

                   <div>
                    <p style={styles.docLabel}>Bank Name</p>
                    <p style={styles.bankValue}>
                      {selectedDriver.bankName || "N/A"}
                    </p>
                  </div>

                   <div>
                    <p style={styles.docLabel}>IFSC CODE</p>
                    <p style={styles.bankValue}>
                      {selectedDriver.ifscCode || "N/A"}
                    </p>
                  </div>

                </div>

              </div>

            </div>

          </div>

        </div>

      )}

    </div>
  );
};

// =========================
// HELPERS
// =========================
const getApprovalColor = (status) => {
  switch (status) {
    case "approved":
      return { bg: "#e0f2fe", text: "#0369a1" };

    case "rejected":
      return { bg: "#fef2f2", text: "#b91c1c" };

    default:
      return { bg: "#fef3c7", text: "#92400e" };
  }
};

// =========================
// STYLES
// =========================
const styles = {
  page: {
    padding: "30px",
    background: "#f8fafc",
    minHeight: "100vh",
    fontFamily: "'Inter', sans-serif"
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "30px",
    flexWrap: "wrap",
    gap: "20px"
  },

  title: {
    margin: 0,
    fontSize: "28px",
    color: "#1e293b",
    fontWeight: "700"
  },

  subtitle: {
    margin: "5px 0 0 0",
    color: "#64748b",
    fontSize: "14px"
  },

  filterGroup: {
    display: "flex",
    gap: "12px",
    alignItems: "center"
  },

  select: {
    padding: "10px 15px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    outline: "none",
    fontSize: "14px",
    background: "#fff"
  },

  badgeCount: {
    background: "#1e293b",
    color: "#fff",
    padding: "10px 18px",
    borderRadius: "8px",
    fontWeight: "600",
    fontSize: "14px"
  },

  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "20px"
  },

  card: {
    background: "#fff",
    borderRadius: "16px",
    padding: "20px",
    boxShadow: "0 4px 6px -1px rgba(0,0,0,0.1)"
  },

  cardTop: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "15px"
  },

  statusBadge: {
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "800"
  },

  approvalBadge: {
    padding: "4px 10px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "800"
  },

  driverName: {
    margin: "0 0 4px 0",
    fontSize: "18px"
  },

  contactInfo: {
    marginBottom: "15px",
    color: "#64748b"
  },

  vehicleBox: {
    background: "#f8fafc",
    padding: "12px",
    borderRadius: "10px",
    marginBottom: "15px"
  },

  label: {
    fontSize: "11px",
    color: "#94a3b8",
    fontWeight: "700"
  },

  vehicleText: {
    fontSize: "14px"
  },

  plateNumber: {
    fontSize: "13px",
    color: "#64748b"
  },

  statsRow: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "10px",
    marginBottom: "20px"
  },

  statItem: {
    display: "flex",
    flexDirection: "column"
  },

  statLabel: {
    fontSize: "11px",
    color: "#94a3b8"
  },

  statValue: {
    fontWeight: "700"
  },

  viewBtn: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "1px solid #e2e8f0",
    background: "#f8fafc",
    cursor: "pointer",
    fontWeight: "600"
  },

  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(15, 23, 42, 0.7)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000
  },

  modal: {
    background: "#fff",
    width: "95%",
    maxWidth: "700px",
    borderRadius: "24px",
    padding: "30px",
    maxHeight: "90vh",
    overflowY: "auto"
  },

  modalHeader: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom: "20px"
  },

  modalTitle: {
    margin: 0,
    fontSize: "22px"
  },

  modalSubtitle: {
    fontSize: "12px",
    color: "#94a3b8"
  },

  closeBtn: {
    border: "none",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    cursor: "pointer"
  },

  sectionTitle: {
    fontSize: "13px",
    color: "#64748b",
    fontWeight: "700",
    marginBottom: "15px"
  },

  docGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "15px",
    marginBottom: "25px"
  },

  docCard: {
    padding: "15px",
    borderRadius: "12px",
    border: "1px solid #e2e8f0"
  },

  docLabel: {
    fontSize: "11px",
    color: "#94a3b8",
    fontWeight: "700",
    margin: 0
  },

  docLink: {
    display: "block",
    color: "#3b82f6",
    fontSize: "12px",
    margin: "10px 0",
    fontWeight: "600"
  },

  previewContainer: {
    width: "100%",
    height: "180px",
    borderRadius: "10px",
    overflow: "hidden",
    background: "#f1f5f9",
    marginTop: "10px",
    border: "1px solid #e2e8f0"
  },

  previewImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover"
  },

  actionRow: {
    display: "flex",
    gap: "8px",
    marginTop: "10px"
  },

  actionBtn: {
    flex: 1,
    border: "none",
    padding: "8px",
    borderRadius: "6px",
    fontSize: "11px",
    fontWeight: "700",
    cursor: "pointer"
  },

  rejectionText: {
    fontSize: "10px",
    color: "#b91c1c",
    marginTop: "8px"
  },

  bankSection: {
    background: "#f8fafc",
    padding: "20px",
    borderRadius: "16px"
  },

  bankGrid: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "20px"
  },

  bankValue: {
    fontSize: "14px",
    fontWeight: "600"
  },

  loading: {
    textAlign: "center",
    padding: "100px",
    fontSize: "20px"
  },

  error: {
    background: "#fef2f2",
    color: "#b91c1c",
    padding: "15px",
    borderRadius: "8px",
    marginBottom: "20px"
  }
};

export default DriverManagement;